import type { PlanEvent, Task } from "../../../../shared/types";
import { WorkHoursStats } from "./WorkHoursStats";
import { CategoryStats } from "./CategoryStats";
import { StatusStats } from "./StatusStats";
import { useStatsCalculation } from "../../hooks/use-stats-calculation";
import { StatCard } from "./StatCard";
import { EventsCard } from "./EventsCard";
import { ProductivityHeatmap } from "./ProductivityHeatmap";

interface StatsViewProps {
  readonly tasks: Task[];
  readonly events: PlanEvent[];
}

export function StatsView({ tasks, events }: StatsViewProps) {
  const stats = useStatsCalculation(tasks, events);

  const maxCategoryCount = Math.max(
    ...Object.values(stats.categoryCounts).map((v) =>
      typeof v === "number" ? v : 0,
    ),
  );

  const maxStatusCount = Math.max(
    stats.statusCounts.todo,
    stats.statusCounts.doing,
    stats.statusCounts.done,
  );

  return (
    <div className="flex flex-col gap-4 pt-4">
      <WorkHoursStats events={events} />
      <div className="grid grid-cols-2 gap-3">
        <StatCard
          value={stats.totalTasks}
          label="Tâches actives"
          color="accent"
        />
        <StatCard
          value={`${stats.completionRate}%`}
          label="Taux de complétion"
          color="success"
        />
        <StatCard
          value={stats.completedThisWeek}
          label="Complétées cette semaine"
          color="accent"
        />
        <StatCard
          value={stats.streak}
          label="Jours d'activité"
          color="amber-500"
        />
      </div>

      <CategoryStats
        categoryCounts={stats.categoryCounts}
        maxCategoryCount={maxCategoryCount}
      />

      <StatusStats
        maxStatusCount={maxStatusCount}
        statusCounts={stats.statusCounts}
      />

      <EventsCard eventsThisWeek={stats.eventsThisWeek} />

      <ProductivityHeatmap tasks={tasks} events={events} />
    </div>
  );
}
